import { useCallback, useState } from "react";

/**
 * Brukerinnstillinger som overlever at fanen lukkes.
 *
 * Portert fra feltappens `usePreference`
 * (`apps/mobile/src/state/SessionProvider.tsx:96-118`), med samme
 * noekkelnavn — en bruker som slaar paa blackout i appen og paa nettflata
 * skal kjenne igjen det samme valget, ikke to som heter det samme.
 *
 * Nettflata har ingen context aa henge dette paa, saa tilstanden bor i
 * `App.tsx`. Det er riktig saa lenge det er én innstilling; blir det flere
 * flater som trenger dem, er en provider neste steg.
 */

export const PREF_BLACKOUT = "infoflyt.blackout.v1";

export function usePreference(
  key: string,
  fallback: boolean,
): [boolean, (v: boolean) => void] {
  const [value, setValue] = useState<boolean>(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw === null ? fallback : raw === "1";
    } catch {
      return fallback;
    }
  });
  const set = useCallback((v: boolean): void => {
    setValue(v);
    try {
      localStorage.setItem(key, v ? "1" : "0");
    } catch {
      // Privat modus kan nekte lagring. Valget gjelder da bare denne oekta.
    }
  }, [key]);
  return [value, set];
}
